import { useMutation } from '@tanstack/react-query';
import getSRTTrunkNewPassword from 'API/SRT/getSRTTrunkNewPassword';

/**
 * Generates a fresh SIP password for an SRT trunk.
 *
 * A mutation rather than a query despite being a GET: each call rotates the
 * password, so it must never be cached, retried or refetched on its own.
 *
 * @returns TanStack mutation taking the trunk id and resolving to the password.
 */
const useGetSRTTrunkPassword = () =>
    useMutation({
        mutationFn: async (id) => {
            const res = await getSRTTrunkNewPassword(id);
            return res.data;
        },
    });

export default useGetSRTTrunkPassword;
